import type { ToolRendererProps } from '@chatsdet/ui';
import { Text } from '@chatsdet/ui';
import type { ExecuteSqlInput, ExecuteSqlOutput } from '../types';

export function ExecuteSqlRenderer({
  input,
  output,
}: ToolRendererProps<ExecuteSqlInput, ExecuteSqlOutput>) {
  const query = input?.query ?? output?.query ?? '';

  return (
    <div className="space-y-2">
      {query && (
        <pre className="font-mono text-xs whitespace-pre-wrap rounded bg-muted/60 border border-border p-2 overflow-x-auto">
          {query}
        </pre>
      )}
      {output && output.ok === false && (
        <Text size="xs" className="text-destructive">
          {output.error}
        </Text>
      )}
      {output && output.ok === true && (
        <Text size="xs" className="text-muted-foreground">
          {output.rowCount.toLocaleString()} row{output.rowCount === 1 ? '' : 's'}
          {output.truncated ? ' (truncated)' : ''} · {output.durationMs}ms
        </Text>
      )}
    </div>
  );
}
